import React from 'react';
import s from './DisconnectModal.module.css';
import Modal from '../../../../shared/ui/modal/Modal';
import Button from '../../../../shared/ui/button/Button';
import Spinner from '../../../../shared/ui/spinner/Spinner';
import IconProfileDelete from '../../../../shared/ui/icons/IconProfileDelete';

interface DeleteAccountModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isLoading: boolean;
}

const DeleteAccountModal: React.FC<DeleteAccountModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    isLoading,
}) => {
    if (!isOpen) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose} width="400px">
            {isLoading ? (
                <div className={s.modal}>
                    <h3 className={s.title}>Deleting Account...</h3>
                    <Spinner />
                </div>
            ) : (
                <div className={s.modal} onClick={(e) => e.stopPropagation()}>
                    <div className={s.iconWrapper}>
                        <IconProfileDelete />
                    </div>
                    <h3 className={s.title}>Are you sure you want to delete this profile?</h3>
                    <p className={s.subtitle}>
                        This action will permanently remove the user's personal information. Once
                        you delete this, it can’t be undone.
                    </p>
                    <div className={s.buttons}>
                        <Button onClick={onClose} text="Cancel" />

                        <Button
                            onClick={onConfirm}
                            text="Delete"
                            style={{ backgroundColor: '#FF1A1A', color: '#fff' }}
                        />
                    </div>
                </div>
            )}
        </Modal>
    );
};

export default DeleteAccountModal;
